module.exports = "<a (click)=\"open()\">read more</a>\n"